import { useQuery } from "@tanstack/react-query";
import { deleteMedia } from "../api/real-cookie-banner.js";
import { useStores } from "../store/root.js";
import { QueryKeys } from "../util/query-keys.js";
/**
 * Delete given media at RCB API.
 */ function useMediaDelete(media) {
    const { rcbAuthenticationStore } = useStores();
    const id = media?.id;
    return useQuery(QueryKeys.deleteMedia(id), ({ signal })=>deleteMedia({
            signal,
            language: "en",
            headers: {
                Authorization: `Bearer ${rcbAuthenticationStore?.session?.jwt}`
            },
            params: {
                id: String(id)
            }
        }), {
        staleTime: Infinity,
        retry: false,
        enabled: String(id)?.trim().length > 0 && !isNaN(Number(id))
    });
}
export { useMediaDelete };
